module.exports = __webpack_public_path__ + "media/Vechicle_in_front_slowing_stopping.2ccb0b9b.mp4";